'use client'

import React, { FC, ReactElement } from 'react'
import { createPortal } from 'react-dom'
import styles from './SetPfpButton.module.css'
import classNames from 'classnames'
import { Inscription } from '@/utils/types/inscription'
import Icon from '@/icons/set-pfp'
import Tooltip from '@mui/material/Tooltip'
import Wallet from '@/utils/wallet'
import axios from 'axios'
import { API_URL } from '@/utils/constants'

import Modal from './success-modal'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const SetPfpButton: FC<{ className?: string; inscription: Inscription }> = (
	props
): ReactElement => {
	const [open, setOpen] = React.useState(false)

	const handleClick = async (evt: any) => {
		evt.preventDefault()
		evt.stopPropagation()

		const message = props.inscription.id
		const address = Wallet.getTaprootAddress()

		const signature = await Wallet.signInscription(message)
		setOpen(true)
		await axios.post(`${API_URL}/wallet/${address}/icon`, {
			inscription: message,
			signature
		})
		Wallet.fetchProfile()
	}

	const onClose = (_evt: any) => {
		//evt.preventDefault()
		//evt.stopPropagation()
		setOpen(false)
	}

	return (
		<>
			<Tooltip placement="top" title="Set as PFP">
				<div
					className={classNames(props.className, styles.root)}
					onClick={handleClick}
					role="button"
					tabIndex={0}
					onKeyDown={onKeyboardClick(handleClick)}
				>
					<Icon className={styles.icon} />
				</div>
			</Tooltip>
			{createPortal(
				<Modal open={open} onClose={onClose} inscription={props.inscription} />,
				document.body
			)}
		</>
	)
}

export default SetPfpButton
